export default __webpack_public_path__ + "5dd904d61b2ba9a66aff0afe9bcd260e.svg";